export default __webpack_public_path__ + "static/istockphoto-1158762452-1024x1024-601868e25ec3a362a4c0b0b9cfc64cb3.jpg";